module.exports = __webpack_public_path__ + "media/images/favicon/favicon-60-fb0d9dc2f1a6c9abe12e5b230789d793.png";